import SendInvitationButton from '@/components/actions/send-invitation/send-invitation-button';
import { Alert } from '@/components/ui/alert';
import { Text } from '@chakra-ui/react';
import type { Participant } from '@fluenceur/types';
import { isCreatorParticipant } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';

interface AffiliateAlertProps {
  participant: Participant;
  onInvitationSent: () => void;
}

const InvitableAffiliateAlert = ({ participant, onInvitationSent }: AffiliateAlertProps) => {
  const { t } = useTranslation();
  // Only show for creator participants (not affiliates), and only when a social
  // account carries the thread: the invitation is addressed to that account.
  if (!isCreatorParticipant(participant) || !participant.socialProfileId) {
    return null;
  }

  const handleSuccess = () => {
    onInvitationSent();
  };

  return (
    <Alert
      variant="subtle"
      title={t('messages.invitableAffiliateAlert.title')}
      endElement={
        <SendInvitationButton
          size="sm"
          colorPalette="deepForest"
          creatorId={participant.socialProfileId}
          onSuccess={handleSuccess}
        >
          {t('messages.invitableAffiliateAlert.buttonText')}
        </SendInvitationButton>
      }
      width="full"
      colorPalette="deepForest"
      bg="softCream"
      color="deepForest"
      rounded="none"
      size="md"
      px={6}
      py={4}
      alignItems="center"
    >
      <Text fontWeight="light" fontSize="sm" color="deepForest">
        {t('messages.invitableAffiliateAlert.description')}
      </Text>
    </Alert>
  );
};

export default InvitableAffiliateAlert;
